import { useState, useEffect } from 'react'

/**
 * Returns the current theme ('dark' | 'light') by reading
 * the data-theme attribute on document.documentElement.
 * Reactively updates when the attribute changes.
 */
export function useTheme(): { theme: 'dark' | 'light'; isDark: boolean } {
  const getTheme = (): 'dark' | 'light' => {
    const attr = document.documentElement.getAttribute('data-theme')
    return attr === 'light' ? 'light' : 'dark'
  }

  const [theme, setTheme] = useState<'dark' | 'light'>(getTheme)

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setTheme(getTheme())
    })
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    })
    return () => observer.disconnect()
  }, [])

  return { theme, isDark: theme === 'dark' }
}
